import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadUsersSuccessAction, usersActionTypes} from '../actions/users';
import {User} from '..';

export interface UsersState {
  users: User[];
}

const initialState: UsersState = {
  users: [],
};

export function UsersReducer(state: UsersState = initialState, action: Action): UsersState {
  switch (action.type) {
    case usersActionTypes.LOAD_SUCCESS:
      return handleLoadUsersSuccessAction(state, action);
    default:
      return state;
  }
}

function handleLoadUsersSuccessAction(state: UsersState, action: LoadUsersSuccessAction): UsersState {
  return Object.assign({}, state, { users: action.payload });
}

export const usersSelectors = {
  users: (state: UsersState) => _.get(state, 'users'),
  usersByType: (state: UsersState, props: string) => {
    return state.users.filter((user: User) => user.department && user.department.toLowerCase() === props.toLowerCase());
  }
};
